import { render } from "./ComponentList.vue?vue&type=template&id=54d61510&scoped=true"
import script from "./ComponentList.vue?vue&type=script&lang=ts"
export * from "./ComponentList.vue?vue&type=script&lang=ts"

import "./ComponentList.vue?vue&type=style&index=0&id=54d61510&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-54d61510"

export default script